export default "__VITE_ASSET__V0mTW7Mw__"